import { HTTPClient } from "@/utils/request.hub";

export default {
  buscarCep: ({ payload }) => HTTPClient.get(`/cep/${payload.cep}`),
  checarViabilidade: ({ payload }) =>
    HTTPClient.get(`/Viabilidade/Vivo/${payload.cep}/${payload.numero}`),
};
